import { render, staticRenderFns } from "./ImpersonateNotification.vue?vue&type=template&id=4fd92534&scoped=true&"
import script from "./ImpersonateNotification.vue?vue&type=script&lang=js&"
export * from "./ImpersonateNotification.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonateNotification.vue?vue&type=style&index=0&id=4fd92534&prod&lang=scss&scoped=true&"
import style1 from "./ImpersonateNotification.vue?vue&type=style&index=1&id=4fd92534&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd92534",
  null
  
)

export default component.exports